import React, { createContext, useContext, useEffect, useState, useCallback, useMemo } from "react";
import api from "@/lib/api";

const SiteContext = createContext(null);

export const SiteProvider = ({ children }) => {
  const [site, setSite] = useState(null);
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    try {
      const { data } = await api.get("/site");
      setSite(data);
    } catch {
      setSite({});
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    load();
  }, [load]);

  const save = useCallback(async (section, values) => {
    const payload = { [section]: values };
    const { data } = await api.put("/site", payload);
    setSite(data);
    return data;
  }, []);

  const value = useMemo(
    () => ({ site, loading, reload: load, save }),
    [site, loading, load, save]
  );

  return <SiteContext.Provider value={value}>{children}</SiteContext.Provider>;
};

export const useSite = () => {
  const ctx = useContext(SiteContext);
  return ctx || { site: null, loading: true };
};

// Convenience helper for sections with fallback
export const useSection = (name) => {
  const { site } = useSite();
  return (site && site[name]) || {};
};
